import { ScrollView, StyleSheet, Text, View } from 'react-native';
import React, { FC, useCallback, useEffect, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { Footer } from '../../components/Footer';
import { IDinningMenu } from '../../models/IDiningMenu';
import DinningMenuItem from './components/DinningMenuItem';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { DinningLayout } from '../../WebLayout';
import { Button } from '../../components/Button';
import { STYLE_VARS } from '../../constants/style-vars';
import MenusApi, { DiningMenuProps } from '../../services/api/menus.api';
import { IDiningMenu } from '../../types/menus.types';
import { COLORS, FONTS } from '../../constants';
import { Loading } from '../../components';

const DinningMenu: FC = () => {
  const isDesktop = useIsDesktop();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [diningMenus, setDiningMenus] = useState<IDiningMenu[]>([]);
  const [total, setTotal] = useState<number>(0);

  const getMenus = useCallback(async (props: DiningMenuProps) => {
    try {
      setIsLoading(true);
      const res = await MenusApi.getDiningMenus(props);
      setDiningMenus(res.data.dining_menus);
      setTotal(res.data.total);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleLoadMore = useCallback(async () => {
    if (diningMenus.length < total) {
      try {
        setIsLoading(true);
        const res = await MenusApi.getDiningMenus({
          page: Math.ceil(diningMenus.length / 20) + 1,
        });
        setDiningMenus([...diningMenus, ...res.data.dining_menus]);
        setTotal(res.data.total);
      } catch (error: any) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  }, [diningMenus, total]);

  useEffect(() => {
    getMenus({});
  }, [getMenus]);

  if (isDesktop()) {
    return (
      <DinningLayout
        title="Dining Menus"
        icon={require('../../assets/dining-menus.png')}
        current={3}
      >
        <View>
          {diningMenus &&
            diningMenus.map((menu) => (
              <DinningMenuItem item={menu} key={menu.id} />
            ))}
        </View>
        {isLoading === false && diningMenus.length === 0 ? (
          <View style={styles.noDataWrapper}>
            <Text style={[styles.noDataText, { fontSize: 20 }]}>
              THERE ARE CURRENTLY NO DINING MENU
            </Text>
          </View>
        ) : (
          <></>
        )}
        {isLoading && <Loading style={{ paddingVertical: 30 }} />}
        {total > diningMenus.length && (
          <View style={{ marginVertical: 30, alignSelf: 'center' }}>
            <Button
              text="LOAD MORE"
              style={STYLE_VARS.blueButton}
              onPress={handleLoadMore}
              disabled={isLoading}
            />
          </View>
        )}
      </DinningLayout>
    );
  }
  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="Dining Menus"
          icon={require('../../assets/dining-menus.png')}
          description={''}
          haveGoBackButton={true}
        />
      </View>
      <View style={styles.container}>
        {diningMenus &&
          diningMenus.map((menu) => (
            <DinningMenuItem item={menu} key={menu.id} />
          ))}
      </View>
      {isLoading === false && diningMenus.length === 0 ? (
        <View style={styles.noDataWrapper}>
          <Text style={[styles.noDataText, { fontSize: 16 }]}>
            THERE ARE CURRENTLY NO DINING MENU
          </Text>
        </View>
      ) : (
        <></>
      )}
      {isLoading && <Loading style={{ paddingVertical: 30 }} />}
      {total > diningMenus.length && (
        <View style={{ marginVertical: 30, alignSelf: 'center' }}>
          <Button
            text="LOAD MORE"
            style={STYLE_VARS.blueButton}
            onPress={handleLoadMore}
            disabled={isLoading}
          />
        </View>
      )}
      <Footer />
    </ScrollView>
  );
};

export default DinningMenu;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 20,
  },
  noDataText: {
    color: COLORS.GREEN,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
  },
});
